<style>
	
	  
	  .ql-editor {
	    min-height: 300px;
	  }
</style>

<template>
	<div>
		<div>最小间隔时间</div>
		<div class="line-box">
			<el-input type="number"  placeholder="请填写最小间隔时间(秒>=3秒)" v-model="pushInfo.inter"></el-input>
		</div>
		<div>弹窗次数</div>
		<div class="line-box">
			<el-input type="number"  placeholder="请填写次数" v-model="pushInfo.times"></el-input>
		</div>
		<div>标题</div>
		<div class="line-box">
			<el-input  placeholder="请填写标题" v-model="pushInfo.title"></el-input>
		</div>
		<div>内容</div>
		<div>
			<quill-editor 
			      ref="quillEditor"
			      v-model="pushInfo.content"
			      :options="editorOptions"
			      @blur="onEditorBlur"
			      @focus="onEditorFocus"
			      @change="onEditorChange"
			    />
		</div>
		<div style="width: 100%; margin-top: 20px;">
			<el-button style="width: 100%;" type="primary" @click="addProduct">确认修改</el-button>
		</div>
	</div>
</template>

<script>
	import { quillEditor  } from 'vue-quill-editor';
	
	export default {
		props:['pushInfo'],
		name:'editPush',
		components: { quillEditor  },
		data(){
			return {
				editorOptions: {
					theme: 'snow', // Quill主题，支持snow和bubble
					placeholder: '在此输入内容...',
					modules: {
						toolbar: [
								  [{ 'font': [] }],                    // 字体
								  [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
								  [{ 'color': [] }, { 'background': [] }], // 字体颜色和背景色
								  ['bold', 'italic', 'underline'],       // 样式
								  [{ 'header': 1 }, { 'header': 2 }],    // 标题
								  [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
								  ['image', 'link'],                     // 插入图片和链接
								  [{ 'align': [] }],                     // 对齐方式
							],
						},
				},
				headers:{
					Authorization:''
				}
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
		methods: {
			onEditorBlur() {
			      console.log('Editor has lost focus');
			    },
			    onEditorFocus() {
			      console.log('Editor is focused');
			    },
			    onEditorChange(content, delta, source, editor) {
			      console.log('Editor content has changed:', content);
			    },
			addProduct() {
				// 验证格式
				if(this.pushInfo.inter == ""){
					return this.$message({ message: '请填写最小间隔', type: 'warning' });
				}
				if(this.pushInfo.times == ""){
					return this.$message({ message: '请填写次数', type: 'warning' });
				}
				if(this.pushInfo.title.trim() == ""){
					return this.$message({ message: '请填写标题', type: 'warning' });
				}
				if(this.pushInfo.content.trim() == ""){
					return this.$message({ message: '请填写内容', type: 'warning' });
				}
				// 提交上传
				this.submit();
			},
			submit(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '修改中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Ad/editPush", this.pushInfo).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '编辑成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			beforeUpload(file){
			},
			UploadSuccess1(res, file, fileList){
				if(res.code == 200)
				{
					this.form.img1_url = res.file_path;
					this.form.img1_fullurl = this.$http_host + res.file_path;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadSuccess2(res, file, fileList){
				if(res.code == 200)
				{
					this.form.img2_url = res.file_path;
					this.form.img2_fullurl = this.$http_host + res.file_path;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			}
		},
	}
</script>
